'use strict';
angular.module('appMarketplace')
    .controller('UpdatePasswordHintCtrl', ['$scope', '$location', '$state', '$window', '$stateParams',
                                          'NotificationService', 'UserService', 'NavigationService', 'UrlService',
                                          function ($scope, $location, $state, $window, $stateParams,
                                                    NotificationService, UserService, NavigationService, UrlService) {

        UserService.getPasswordHint(function successCallback(data) {
            $scope.userQuestions = data;
            $scope.userQuestions.userQuestion = $scope.userQuestions.userQuestion || 1; //select default user question

            $scope.actions = [];
            $scope.manualUpdate = $location.search().manualUpdate === "true" || $stateParams.manualUpdate; //true if user selected update password hint, false if password hint is expired
            if ($scope.manualUpdate) {
                $scope.actions.push("Close");
            }

            $scope.window = angular.element("#updatePasswordHintForm").kendoWindow({    // hint
                actions: $scope.actions,
                modal: true,
                pinned: true,
                resizable: false,
                title: "Update password hint",
                width: "360px",
                visible: false,
                autoFocus: false,
                close: function () {
                    UserService.showRequiredFormIfAnyNeeded(UrlService.getHashFromUrl() === 'update-password-hint');
                },
                deactivate: function () {
                    $scope.validator.destroy();
                    $scope.window.destroy();
                }
            }).data("kendoWindow").center().open();

            var formErrorTemplate = kendo.template(angular.element("#formErrorTemplate").html());
            $scope.validator = angular.element("#updatePasswordHintForm").kendoValidator({
                errorTemplate: formErrorTemplate,
                messages: {
                    required: "Field is required"
                }
            }).data("kendoValidator");

            $scope.closeWindow = function () {
                $scope.window.close();
            };

            $scope.logOut = function () {
                $window.location.href = UrlService.createAbsoluteUrl('/useradmin/logout.jsp');
            };

            $scope.updatePasswordHint = function () {
                if (!$scope.validator.validate()) {
                    return;
                }
                UserService.updatePasswordHint($scope.userQuestions.userQuestion, $scope.userQuestions.userAnswer,
                    function successCallback() {
                        NavigationService.getCurrentAccount(function successCallback(currentAccount) {
                            currentAccount.passwordHintUpdateNeeded = false;
                        });
                        $scope.closeWindow();
                        NotificationService.showSuccessMessage('Updated password hint');
                    }, function errorCallback(responseError) {
                        var errorMsg = responseError.message;
                        if (errorMsg) {
                            NotificationService.showErrorMessage(errorMsg);
                        }
                        angular.forEach(responseError.validationErrors, function (error) {
                            $scope.formErrors = [];
                            $scope.formErrors.push(error);
                        });
                    });
            };
        }, function errorCallback(responseError) {
            NotificationService.showValidationErrors(responseError);
        });
    }]);


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/js/main/controllers/update-password-hint-ctrl.js
// module id = 258
// module chunks = 21